import api from './api';

/**
 *
 * @returns listo of barber shop
 */
export const getImpacts = async () => {
  return await api.get('impact');
};
